import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/ui-common/src/Popup/Popup.styled.ts",
    _templateObject2,
    _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
export var ContentWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: absolute;\n  backface-visibility: hidden;\n  background: white;\n  width: ", ";\n  max-width: ", ";\n  min-height: ", ";\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto;\n  height: max-content;\n  border-radius: 4px;\n  box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.35);\n"])), function (_ref) {
  var width = _ref.width;
  return width;
}, function (_ref2) {
  var maxWidth = _ref2.maxWidth;
  return maxWidth;
}, function (_ref3) {
  var minHeight = _ref3.minHeight;
  return minHeight !== null && minHeight !== void 0 ? minHeight : 'max-content';
});
export var Backdrop = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 25, 0.4);\n"])));
export var Container = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  width: 100vw;\n  height: 100vh;\n  z-index: 1200;\n"])));